import { Theme } from "@mui/material";
import { ROWS } from "./getRowValues";

const tableBorderRadius = "12px";

export const emptyRowsStyles = {
  maxWidth: { md: 150, xl: 170 },
  px: { md: 2, xl: 3 },

  borderBottom: "none",
  verticalAlign: "top",
};

export const getBorderStyles = (theme: Theme, isPopular: boolean) => {
  return isPopular
    ? `1px solid ${theme.palette.primary.main}`
    : `1px solid transparent`;
};

export const getSideBorders = (theme: Theme, isPopular: boolean) => {
  return {
    borderLeft: getBorderStyles(theme, isPopular),
    borderRight: getBorderStyles(theme, isPopular),
  };
};

export const getHeaderWrapperStyles = (theme: Theme, isPopular: boolean) => ({
  px: { md: 2, xl: 3 },
  pb: { md: 2 },
  pt: { md: 3 },

  backgroundColor: `${isPopular ? "#FFF8F3" : "transparent"}`,

  borderTopLeftRadius: tableBorderRadius,
  borderTopRightRadius: tableBorderRadius,
  ...getSideBorders(theme, isPopular),
  // border-top for the first row - header
  borderTop: getBorderStyles(theme, isPopular),
});

export const getRowStyles = (theme: Theme, isPopular: boolean) => ({
  px: { md: 2, xl: 3 },
  verticalAlign: "top",

  backgroundColor: `${isPopular ? "#FFF8F3" : "transparent"}`,
  borderBottom: "none",
  ...getSideBorders(theme, isPopular),
});

export const getRowStylesByName = (
  name: string,
  theme: Theme,
  isPopular: boolean
) => {
  switch (name) {
    case ROWS.name:
      return {
        borderBottom: "none",
        verticalAlign: "top",
      };
    case ROWS.description:
      return {
        ...getRowStyles(theme, isPopular),
        pb: { xs: 2, md: 3 },
      };
    case ROWS.totalPrice:
      return {
        ...getRowStyles(theme, isPopular),
        pb: { xs: 4, md: 4 },
      };
    case ROWS.button:
      return getRowStyles(theme, isPopular);
    case ROWS.monthlyPrice:
      return {
        ...getRowStyles(theme, isPopular),
        pb: { md: 2.5 },
      };
    default:
      return {};
  }
};

export const attributeNameCellStyles = {
  maxWidth: { md: 150, xl: 170 },
  px: 2,
  py: 1.5,

  fontSize: 15,
  fontWeight: 600,
  verticalAlign: "center",
  borderBottom: "none",
};

export const getAttributeRowStyles = (
  theme: Theme,
  isPopular: boolean,
  isLastRow: boolean
) => ({
  px: { md: 2, xl: 3 },
  py: { md: 2.5, xl: 3 },

  fontSize: 16,
  verticalAlign: "center",
  textAlign: "center",
  color: theme.palette.text.secondary,
  backgroundColor: `${isPopular ? "#FFF8F3" : "transparent"}`,

  ...getSideBorders(theme, isPopular),

  // border-bottom for the last row
  borderBottom: isLastRow
    ? getBorderStyles(theme, isPopular)
    : `1px solid transparent`,
  borderBottomLeftRadius: isLastRow && isPopular ? tableBorderRadius : 0,
  borderBottomRightRadius: isLastRow && isPopular ? tableBorderRadius : 0,
});
